
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pracodawca",
      function () {
        return require("private-next-pages/pracodawca.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pracodawca"])
      });
    }
  